import CheckPromotion from "./CheckPromotion/CheckPromotion";
import { Dispatch, SetStateAction } from "react";
import AskPromotion from "./AskPromotion/AskPromotion";
import styles from "./SitePromotion.module.scss";
import BackButton from "src/assets/images/icon/back_btn.svg";
import { useIsOpenSelectProduct } from "src/hooks/recoil/useIsOpenSelectProduct";
import useProductInfo from "src/mocks/useProductInfo";
import { useIsDspProduct } from "src/hooks/recoil/useIsDspProduct";
import { useTranslation } from "react-i18next";

// 모든 제품 공용으로 사용하게 리팩토링
interface ISitePromotionUIProps {
  toggleAskPromotionOn: boolean;
  setToggleAskPromotionOn: Dispatch<SetStateAction<boolean>>;
}
const SitePromotionUI = ({
  toggleAskPromotionOn,
  setToggleAskPromotionOn,
}: ISitePromotionUIProps) => {
  const { setIsOpenSelectProduct } = useIsOpenSelectProduct();
  const { product, productName } = useProductInfo();
  const { name, word } = product || {};
  const { isDspProduct } = useIsDspProduct();
  const { t } = useTranslation();
  const dspWord = t("home.productInfo.dspWord");
  return (
    <div className={styles.siteContainer}>
      <div className={styles.siteTitleBox}>
        <button
          className={styles.backButton}
          onClick={() => {
            setIsOpenSelectProduct(true);
          }}
        >
          <img src={BackButton} alt="back" />
          <span className={styles.backButtonText}>
            {t("common.backToHome")}
          </span>
        </button>
        <h3 className={styles.siteTitle}>
          {productName}
          {/* {!toggleAskPromotionOn
            ? productName + " Cloud Premium"
            : t("siteType.premium.askTitle")} */}
        </h3>
        <p className={styles.siteDesc}>
          {isDspProduct ? dspWord : word}
          {/* {!toggleAskPromotionOn
            ? t("siteType.premium.subTitle")
            : t("siteType.premium.askSubTitle")} */}
        </p>
      </div>
      <div>
        {toggleAskPromotionOn ? (
          <>
            {/* 문의하기 */}
            <AskPromotion setToggleAskPromotionOn={setToggleAskPromotionOn} />
          </>
        ) : (
          <>
            {/* 프리미엄 코드 등록 */}
            <CheckPromotion
              toggleAskPromotionOn={toggleAskPromotionOn}
              setToggleAskPromotionOn={setToggleAskPromotionOn}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default SitePromotionUI;
